import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { ApplicationType } from '@maia/config';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, Observable, of } from 'rxjs';
import { AppContextService } from '../services';

export const LoggedInGuard: CanMatchFn = (): Observable<boolean> => {
  const securityService: OidcSecurityService = inject(OidcSecurityService);
  const appContext: AppContextService = inject(AppContextService);

  const activeApplication: ApplicationType | null = appContext.selectedApplication();
  if (!activeApplication) return of(false);

  return securityService.isAuthenticated(activeApplication).pipe(catchError(() => of(false)));
};
